import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import FEATURE_COLORS from "../constants/FeatureColors";
import { useEffect, useState } from "react";
import { VisualizationAttr } from "../../../CommonElements";
import showDetail from "../utils/showDetail";

const DetailCalendarModal = ({ data, selectedEvent, isOpen, toggle }) => {
  console.log(
    "detailEvent",
    data,
    selectedEvent?.type,
    selectedEvent && data[selectedEvent?.type]
  );

  const [selectedData, setSelectedData] = useState(undefined);

  useEffect(() => {
    selectedEvent &&
      setSelectedData(
        data[selectedEvent?.type].filter(
          (item) => item?.id === selectedEvent?.id
        )
      );
  }, [selectedEvent]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size={"lg"}>
      <ModalHeader
        className={`text-${FEATURE_COLORS.bootstrapColor[selectedEvent?.type]}`}
        toggle={toggle}
      >
        {selectedEvent?.title}
      </ModalHeader>
      <ModalBody>
        <div className="row row-cols-2">
          <VisualizationAttr label={"Tipe"} content={selectedEvent?.type} />
          {selectedData?.length > 0 &&
            showDetail(selectedData[0], selectedEvent?.type)}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>
          Kembali
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DetailCalendarModal;
